import { render, staticRenderFns } from "./PrintAttributeDistributionChart.vue?vue&type=template&id=b7f27c6c&scoped=true&"
import script from "./PrintAttributeDistributionChart.vue?vue&type=script&lang=js&"
export * from "./PrintAttributeDistributionChart.vue?vue&type=script&lang=js&"
import style0 from "./PrintAttributeDistributionChart.vue?vue&type=style&index=0&id=b7f27c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f27c6c",
  null
  
)

/* custom blocks */
import block0 from "./PrintAttributeDistributionChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7f27c6c')) {
      api.createRecord('b7f27c6c', component.options)
    } else {
      api.reload('b7f27c6c', component.options)
    }
    module.hot.accept("./PrintAttributeDistributionChart.vue?vue&type=template&id=b7f27c6c&scoped=true&", function () {
      api.rerender('b7f27c6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/print/report/survey-analysis/charts/PrintAttributeDistributionChart.vue"
export default component.exports